import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { usePetitionSettingsPageData } from 'src/app/pages/petitionEditV2/pageContext';

import { useClosePetitionModal } from './useClosePetitionModal';

export function useClosePetition() {
	const track = useTracking();
	const settingsData = usePetitionSettingsPageData();
	const {
		petition: {
			id: petitionId,
			signatureState: {
				signatureCount: { displayed: signatureCount },
			},
			promotionStats,
		},
	} = settingsData.data;
	const { refreshData } = settingsData.actions;

	const closePetition = useClosePetitionModal();

	const handleClosePetition = useCallback(async () => {
		void track('petition_settings_close_petition_button_click', { petition_id: petitionId });
		const modalResult = await closePetition({
			petitionId,
			promotionStats,
			trackingData: { signatureCount },
		}).waitForResult();
		if (modalResult?.status === 'ok') refreshData();
	}, [closePetition, petitionId, promotionStats, refreshData, signatureCount, track]);

	return { actions: { handleClosePetition } };
}
